import { render, staticRenderFns } from "./BouErrorRequestDetails.vue?vue&type=template&id=121f465a&"
import script from "./BouErrorRequestDetails.vue?vue&type=script&lang=js&"
export * from "./BouErrorRequestDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports